import { Job } from "../types/jobProperties";
import type { Node } from "@xyflow/react";
import { Pipeline } from "../types/pipelineProperties";

export const nodes: Node[] = [
    // REDBEE PIPELINE
  {
    id: Job.REDBEE_MSS_DELIVERY.key,
    position: { x: -200, y: 0 },
    data: { label: Job.REDBEE_MSS_DELIVERY.label },
  },
  {
    id: Job.ZEUS_CONTENT_DECRYPTION.key,
    position: { x: 150, y: 0 },
    data: { label: Job.ZEUS_CONTENT_DECRYPTION.label },
  },
    // HYDRA PIPELINE
  {
    id: Job.AD_TRACK_DECRYPTION.key,
    position: { x: 500, y: 400 },
    data: { label: Job.AD_TRACK_DECRYPTION.label },
  },
    // HYDRA DASH PIPELINE
  {
    id: Job.HYDRA_ISO_DASH_MEDIAPACKAGE.key,
    position: { x: 850, y: 300 },
    data: { label: Job.HYDRA_ISO_DASH_MEDIAPACKAGE.label },
  },
  {
    id: Job.HYDRA_ISO_DASH_MANIFEST_REWRITE.key,
    position: { x: 1200, y: 300 },
    data: { label: Job.HYDRA_ISO_DASH_MANIFEST_REWRITE.label },
  },
  {
    id: Job.HYDRA_ISO_DASH_CREATE_CASSIE_CONTENT_PACKAGE.key,
    position: { x: 1550, y: 300 },
    data: { label: Job.HYDRA_ISO_DASH_CREATE_CASSIE_CONTENT_PACKAGE.label },
  },
    // HYDRA HLS PIPELINE
  {
    id: Job.HYDRA_HLS_MEDIAPACKAGE.key,
    position: { x: 850, y: 500 },
    data: { label: Job.HYDRA_HLS_MEDIAPACKAGE.label },
  },
  {
    id: Job.HYDRA_HLS_CREATE_CASSIE_CONTENT_PACKAGE.key,
    position: { x: 1200, y: 500 },
    data: { label: Job.HYDRA_HLS_CREATE_CASSIE_CONTENT_PACKAGE.label },
  },

    // APOLLO PIPELINE
  {
    id: Job.APOLLO_THUMBNAILS_GENERATION.key,
    position: { x: 500, y: -100 },
    data: { label: Job.APOLLO_THUMBNAILS_GENERATION.label },
  },
  {
    id: Job.APOLLO_CREATE_CASSIE_THUMBNAIL_PACKAGE.key,
    position: { x: 850, y: -100 },
    data: { label: Job.APOLLO_CREATE_CASSIE_THUMBNAIL_PACKAGE.label },
  },
    // HBBTV PIPELINE
  {
    id: Job.HBBTV_MEDIAPACKAGE.key,
    position: { x: 500, y: 100 },
    data: { label: Job.HBBTV_MEDIAPACKAGE.label },
  },
  {
    id: Job.HBBTV_CAPELLA_PACKAGING.key,
    position: { x: 850, y: 100 },
    data: { label: Job.HBBTV_CAPELLA_PACKAGING.label },
  },
  {
    id: Job.HBBTV_CREATE_CASSIE_CONTENT_PACKAGE.key,
    position: { x: 1200, y: 100 },
    data: { label: Job.HBBTV_CREATE_CASSIE_CONTENT_PACKAGE.label },
  },
  // REVOKED
  {
    id: Pipeline.HBBTV.key,
    position: { x: 1200, y: 0 },
    data: { label: Pipeline.HBBTV.label },
  },
  {
    id: Pipeline.APOLLO.key,
    position: { x: 1200, y: 200 },
    data: { label: Pipeline.APOLLO.label },
  },
  {
    id: Pipeline.HYDRA.key,
    position: { x: 1200, y: 400 },
    data: { label: Pipeline.HYDRA.label },
  },
];

export const edges = [
  {
    source: Job.REDBEE_MSS_DELIVERY.key,
    target: Job.ZEUS_CONTENT_DECRYPTION.key,

  },
    // APOLLO
  {
    source: Job.ZEUS_CONTENT_DECRYPTION.key,
    target: Job.APOLLO_THUMBNAILS_GENERATION.key,
  },

  {
    source: Job.APOLLO_THUMBNAILS_GENERATION.key,
    target: Job.APOLLO_CREATE_CASSIE_THUMBNAIL_PACKAGE.key,
  },
    // HBBTV
  {
    source: Job.ZEUS_CONTENT_DECRYPTION.key,
    target: Job.HBBTV_MEDIAPACKAGE.key,
  },
  {
    source: Job.HBBTV_MEDIAPACKAGE.key,
    target: Job.HBBTV_CAPELLA_PACKAGING.key,
  },

  {
    source: Job.HBBTV_CAPELLA_PACKAGING.key,
    target: Job.HBBTV_CREATE_CASSIE_CONTENT_PACKAGE.key,
  },
    // HYDRA
  {
    source: Job.ZEUS_CONTENT_DECRYPTION.key,
    target: Job.AD_TRACK_DECRYPTION.key,
  },

    // HYDRA DASH
  {
    source: Job.AD_TRACK_DECRYPTION.key,
    target: Job.HYDRA_ISO_DASH_MEDIAPACKAGE.key,
  },
  {
    source: Job.HYDRA_ISO_DASH_MEDIAPACKAGE.key,
    target: Job.HYDRA_ISO_DASH_MANIFEST_REWRITE.key,
  },
  {
    source: Job.HYDRA_ISO_DASH_MANIFEST_REWRITE.key,
    target: Job.HYDRA_ISO_DASH_CREATE_CASSIE_CONTENT_PACKAGE.key,
  },
    // HYDRA HLS
  {
    source: Job.AD_TRACK_DECRYPTION.key,
    target: Job.HYDRA_HLS_MEDIAPACKAGE.key,
  },
  {
    source: Job.HYDRA_HLS_MEDIAPACKAGE.key,
    target: Job.HYDRA_HLS_CREATE_CASSIE_CONTENT_PACKAGE.key,
  }];
